import classNames from 'classnames';
import React from 'react';
import { PatternFormat } from 'react-number-format';

import css from './TextInputDate.module.scss';
import { DateTime } from 'luxon';

export enum TextInputDateType {
  Date = 'date',
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Tel = 'tel',
  Text = 'text',
  TextArea = 'textarea',
}

interface Props {
  name?: string;
  className?: string;
  cols?: number;
  rows?: number;
  type?: TextInputDateType;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  setValue?: boolean;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
}

const TextInputDate: React.FC<Props> = ({
  className,
  cols,
  rows,
  type,
  onChange,
  setValue,
  ...attr
}) => {
  const classes = classNames(
    css.TextInput,
    { [css.isSetValue]: setValue },
    className,
  );

  return (
    <PatternFormat
      {...attr}
      valueIsNumericString
      format="####/##/##"
      className={classes}
      onChange={onChange}
      mask=" "
      placeholder="1990/12/01"
      isAllowed={({ formattedValue }) => {
        const [yearStr, monthStr, dayStr]: (string | undefined)[] =
          formattedValue.split('/');

        if (yearStr.trim().length !== 4) {
          return true;
        }
        if (monthStr.trim().length !== 2) {
          return true;
        }
        if (dayStr.trim().length !== 2) {
          return true;
        }

        const [year, month, day] = [yearStr, monthStr, dayStr].map((v) =>
          Number(v),
        );

        if ([year, month, day].some((v) => isNaN(v))) return true;
        if (year > 9999 || month > 12 || day > 31) return false;

        const dt = DateTime.fromObject({
          year,
          month,
          day,
        });
        return dt.isValid;
      }}
    />
  );
};

export default TextInputDate;
